import { render, staticRenderFns } from "./TC.vue?vue&type=template&id=b07c9112&scoped=true&"
var script = {}
import style0 from "./TC.vue?vue&type=style&index=0&id=b07c9112&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07c9112",
  null
  
)

export default component.exports